import React, { Fragment } from 'react'
import { Box, Divider, useMediaQuery } from '@material-ui/core'

import { ButtonColorPicker } from 'components'

import { CompactModeCustomization } from '../'

import constants from 'constants/index'
import theme from 'theme'

const ColorCustomization = () => {
  const mdUp = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <Fragment>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        width="100%"
      >
        <ButtonColorPicker
          controlName="primaryColor"
          name="Cor Primária"
          permission={constants.permissions.COOKIES.MANAGE}
        />
        <ButtonColorPicker
          controlName="secondaryColor"
          name="Cor Secundária"
          permission={constants.permissions.COOKIES.MANAGE}
        />
        <CompactModeCustomization />
      </Box>
      {mdUp && <Divider orientation="vertical" variant="middle" />}
    </Fragment>
  )
}

export default ColorCustomization
